import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let SelectPlanDialogComponent = {
    selector: "vcSelectPlanDialog",
    templateUrl:
        "/angular/components/campaign-plan/select-plan-dialog.component.html",
    bindings: {
        conversionType: "=",
        plan: "=",
        plans: "=",
        campaign: "=",
        planMax: "&?",
        openIntercomChat: "&?",
    },
    controller: class SelectPlanDialogController {
        // * bindings for typescript compiler *
        public conversionType: any;
        public plan: any;
        public plans: any[];
        public campaign: any;
        public planMax?: any;
        public openIntercomChat?: any;
        // ************************************

        private stage = "plan";
        private selectedInterval = "Monthly";
        private selectedPlanName = "Starter";
        private toggle: any;
        private recommendedPlan: any;
        private recommendedYearlyPlan: any;
        private recommendedMonthlyPlan: any;

        private $scope: any;
        private dialog: DialogUtils;
        private __env: any;

        constructor($scope: any, DialogUtils: DialogUtils, __env: any) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.__env = __env;

            this.toggle = {
                flex: this.__env.product_name == "Ecanvasser" ? 70 : 35,
                gt_md: this.__env.product_name == "Ecanvasser" ? 40 : 20,
                yearly: this.__env.product_name == "Ecanvasser" ? true : false,
            };
        }

        $onInit() {
            this.$scope.$watch(
                () => this.selectedInterval,
                () => {
                    if (this.plans.length == 0) {
                        return;
                    }

                    this.recommendedPlan = this.plans.filter((plan) => {
                        return (
                            plan.cpname == this.selectedPlanName &&
                            plan.cpinterval == this.selectedInterval
                        );
                    })[0];
                },
                true
            );

            this.recommendedPlan = this.plans.filter((plan) => {
                return (
                    plan.cpname == this.selectedPlanName &&
                    plan.cpinterval == this.selectedInterval
                );
            })[0];

            this.recommendedYearlyPlan = this.plans.filter((plan) => {
                return (
                    plan.cpname == this.selectedPlanName &&
                    plan.cpinterval == "Yearly"
                );
            })[0];

            this.recommendedMonthlyPlan = this.plans.filter((plan) => {
                return (
                    plan.cpname == this.selectedPlanName &&
                    plan.cpinterval == "Monthly"
                );
            })[0];
        }

        close() {
            this.dialog.hide(this.plan);
        }

        setPlan(plan) {
            this.plan = plan;
            this.dialog.hide(plan);
        }
    },
};

angular
    .module("campaignplan")
    .component(SelectPlanDialogComponent.selector, SelectPlanDialogComponent);
